import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { AppApi, EDITOR_TYPE, PageType } from '@wix/wix-data-client-common'
import { getRouterDatasetDefinition } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { ReadWriteMode } from '@wix/wix-data-client-types'

export const addRouterDataset = async ({
  editorSdkProxy,
  appApi,
  editorType,
  pageRef,
  collectionName,
  pageType,
  displayName,
  readWriteType,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  editorType: EDITOR_TYPE
  pageRef: PageRef
  collectionName: string
  pageType: PageType
  displayName?: string
  readWriteType?: ReadWriteMode
}) => {
  await editorSdkProxy.components.add({
    pageRef,
    componentDefinition: getRouterDatasetDefinition({
      collectionName,
      pageType,
      editorType,
      displayName,
      readWriteType,
    }),
  })
  await editorSdkProxy.pages.navigateTo({ pageRef })
  await appApi.emit('datasetAdded')
}
